import createApiClient from '../utils/apiClient';

const api = createApiClient();

export interface Stream {
  id: number;
  user_id: number | null;
  device_id: number;
  channelID: string;
  channelType: 'twitch' | 'youtube' | 'kick';
  channelName?: string;
  profilePicture?: string;
  red: number;
  green: number;
  blue: number;
  islive: boolean;
  blink: boolean;
  priority: number;
  muted: boolean;
  watching: boolean;
  locked: boolean;
  created_at: string;
  updated_at: string;
}

const streamService = {
  getByDeviceId: async (deviceId: number) => {
    const response = await api.get<{ streams: Stream[] }>(
      `/streams/device/${deviceId}`
    );
    return response.data.streams;
  },

  create: async (
    deviceId: number,
    channelID: string,
    channelType: 'twitch' | 'youtube' | 'kick',
    red: number = 0,
    green: number = 0,
    blue: number = 0,
    blink: boolean = false,
    priority: number = 999
  ) => {
    const response = await api.post<{ message: string; stream: Stream }>(
      `/streams`,
      {
        device_id: deviceId,
        channelID,
        channelType,
        red,
        green,
        blue,
        blink,
        islive: false,
        priority,
        muted: false,
      }
    );
    return response.data.stream;
  },

  delete: async (streamId: number) => {
    const response = await api.delete<{ message: string }>(
      `/streams/${streamId}`
    );
    return response.data;
  },

  update: async (streamId: number, data: Partial<Stream>) => {
    const response = await api.put<{ message: string; stream: Stream }>(
      `/streams/${streamId}`,
      data
    );
    return response.data.stream;
  },
};

export default streamService;
